import React, { useEffect, useState } from 'react';
import { Skeleton, Empty } from 'antd';
import Chart from '@components/charts/Chart';
import { apiGetDeviceStatisticsByBranch } from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import { formatCurrency } from '@utils/utils';
import { abbreviateBranch, barOptions, PALETTE } from '../dashboardTheme';

const DeviceAllocationChart = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiGetDeviceStatisticsByBranch();
      const branches = res.data?.data?.branches;
      setData(Array.isArray(branches) ? branches : []);
    } catch (error) {
      console.error('Error fetching device allocation data:', error);
      showError('Không thể tải dữ liệu phân bổ thiết bị');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Skeleton active paragraph={{ rows: 8 }} />;
  }

  if (data.length === 0) {
    return <Empty className="chart-empty" description="Chưa có dữ liệu" />;
  }

  const categories = data.map((item) => abbreviateBranch(item.branch_name) || item.branch_code);
  const series = [
    { name: 'Online', data: data.map((item) => parseInt(item.total_online || 0)) },
    { name: 'Offline', data: data.map((item) => parseInt(item.total_offline || 0)) }
  ];

  return (
    <div className="chart-container">
      <Chart
        options={barOptions({
          chart: { type: 'bar', stacked: true },
          colors: [PALETTE.success, PALETTE.danger],
          plotOptions: {
            bar: { columnWidth: '42%', borderRadius: 6, borderRadiusWhenStacked: 'last' }
          },
          stroke: { width: 2, colors: ['#ffffff'] },
          xaxis: { categories },
          yaxis: { labels: { formatter: (val) => formatCurrency(val, 0) } },
          tooltip: { y: { formatter: (val) => `${formatCurrency(val, 0)} thiết bị` } },
          legend: { position: 'top', horizontalAlign: 'right' }
        })}
        type="bar"
        series={series}
        height={340}
      />
    </div>
  );
};

export default DeviceAllocationChart;
